<template>
    <div class="ur-data-grid__header__config" v-click-outside="closeMenu">
        <!-- Click icon -->
        <ur-icon class="ur-data-grid__header__config__icon" type="picto" v-if="isConfigurable" @click="toggleMenu">setting</ur-icon>
        <!-- Popup menu -->
        <div class="ur-data-grid__header__config__menu-wrapper" v-if="isOpenMenu">
            <div class="ur-data-grid__header__config__menu__item-wrapper" ref="iw">
                <div class="ur-data-grid__header__config__menu__dropper" :class="dropperClass(-1)"/>
                <template v-for="(f,idx) in confCols">
                    <div class="ur-data-grid__header__config__menu__item" :data-idx="idx"
                         :class="itemClass(idx)">
                        <ur-icon class="ur-data-grid__header__config__menu__item__holder"
                                 @mousedown="pdn" @mouseup="pup">drawer</ur-icon>
                        <label   class="ur-data-grid__header__config__menu__item__title">{{f.title}}</label>
                        <ur-icon class="ur-data-grid__header__config__menu__item__show"   sm @click="f.show=!f.show"
                                 :class="{'ur-data-grid__header__config__menu__item--icon-active':f.show}"
                                 v-ur-tooltip="gridInfo.opts.msgContextShowIcon">display_password</ur-icon>
                        <ur-icon class="ur-data-grid__header__config__menu__item__freeze" sm @click="toggleFreeze(f,idx)"
                                 :class="{'ur-data-grid__header__config__menu__item--icon-active':f.freeze}"
                                 v-ur-tooltip="gridInfo.opts.msgContextFreezeIcon">pin</ur-icon>
                        <grid-text  class="ur-data-grid__header__config__menu__item__text"  v-model="f.width"
                                    @keydown.enter="confirmColumn" @keypress="isNumber($event)" @keyup="filterNumber($event)"/>
                    </div>
                    <div class="ur-data-grid__header__config__menu__dropper" :class="dropperClass(idx)"
                         v-ur-tooltip.empty="idx===freezeIdx-1?'Freeze grid here':''"/> <!-- i18n -->
                </template>
            </div>
            <div class="ur-data-grid__header__config__menu__action">
                <ur-button main sm @click="confirmColumn">{{gridInfo.opts.msgContextConfirm}}</ur-button> <!-- i18n -->
            </div>
        </div>
    </div>
</template>

<script>
    import clickOutside from '../../common/direc/urDataGridClickOutside.js'
    import gridCheck from "../../edit/urDataGridEditCheckbox.vue"
    import gridText  from "../../edit/urDataGridEditTextField.vue"
    import {_rafThrottle} from '../../util'
    export default {
        name : 'urDataGridHeaderConfig',
        components : {gridCheck, gridText},
        inject : ['gridInfo'],
        data() {return {
            isOpenMenu : false,
            confCols   : [],
            dragIdx  : null,
            startIdx : null,
            freezeIdx: null,
            onDrag   : false,
            //isWrapTop : false, // TODO 상자를 box-shadow inset 하면 이쁠꺼 같은데... 생각만해도 말도 못하게 귀찮다.
            //isWrapBot : false, // .. -> onScroll, wheel, pmv 등... + Style 해서 따로 빼고,
        }},
        created() {
            this._height = 0; // not reactable
        },
        mounted() {
            this.gridInfo.eventBus.$on('open-header-config',this.openMenu);
            this.gridInfo.eventBus.$on('close-header-config',this.closeMenu);
        },
        computed : {
            isConfigurable() {return !!this.gridInfo.opts.configurableColumn}
        },
        methods: {
            // [POPUP] Toggle menu popup -> call open or close
            toggleMenu() {
                if(this.isOpenMenu) {
                    this.closeMenu();
                } else {
                    this.openMenu();
                }
            },
            // [POPUP] Open menu popup
            openMenu() {
                this.initConfCols();
                this.isOpenMenu = true;
            },
            // [POPUP] Close menu popup
            closeMenu() {this.isOpenMenu = false;},
            // []
            itemClass(idx) {
                return {'ur-data-grid__header__config__menu__item--on-drag':idx===this.startIdx};
            },
            // [STYLE] check active
            dropperClass(idx) {
                var clazz = [];
                // 1. active(like hover)
                var ori = this.startIdx, trg = this.dragIdx, len = this.confCols.length;
                if(idx!==ori && idx!==ori-1) {// 내 양옆에꺼 빼고 (&&로 엮어도 되기는 하는데.. 음.. 아마 린트 대상일껄 이거?)
                    if(idx===trg || idx<0 && trg<0 || idx===len-1 && trg>=len) {
                        clazz.push('ur-data-grid__header__config__menu__dropper--active')
                    }
                }
                // 2. freeze idx
                var frz = this.freezeIdx-1;
                if(idx===frz) clazz.push('ur-data-grid__header__config__menu__dropper--freeze')
                return clazz;
            },
            // [STYLE] field title
            title(f) {
                if(!f){return '';}
                if(!f.text){return f.value;}
                if(typeof f.text === 'function') {
                    return f.text();
                } else {
                    return f.text
                }
            },
            // [ACTION] Confirm & make column ->..
            initConfCols() {
                // 1. Reset confCols
                var nCols = [];
                //this.confCols = [];
                // 2. Copy from cols
                this.gridInfo.cols.forEach(f=> {
                    nCols.push({
                        value : f.value,
                        title : this.title(f),
                        show  : !f.hide,
                        width : f.width,
                        freeze: f.freeze
                    })
                });
                this.confCols = nCols;
                // 3. set some value
                this.freezeIdx = this.confCols.findIndex(c=>!c.freeze);
                // 4. reset drag value
                this.dragIdx  = null;
                this.startIdx = null;
            },
            // [ACTION] Confirm & make column ->..
            confirmColumn() {
                // 1. Confirm field's width
                var fields = [];
                this.confCols.forEach((conf,idx) => {
                    var f = this.gridInfo.fmap.get(conf.value);
                    f.hide   = !conf.show;
                    f.width  = conf.width  || null;
                    f.freeze = conf.freeze || null;
                    fields.push(f);
                }); // confCols.length === fields.length === gridInfo.cols.length
                this.gridInfo.cols.splice(0,fields.length,...fields);// 이게 여기서 바뀌는게 맞을까?
                // 2. Re-calc... flag => split columns.
                this.gridInfo.func.recalcWidth(true);
                // x. close menu
                this.closeMenu();

            },
            // [LOGIC] toggle freeze
            toggleFreeze(f,idx) {
                f.freeze=!f.freeze;
                if(f.freeze) {
                    // 앞으로 가면서 다 트루
                    this.confCols.slice(0,idx).forEach(f=>{
                        f.freeze = true;
                    })
                } else {
                    // 뒤으로 가면서.. 음.. 다 지움
                    this.confCols.slice(idx).forEach(f=>{
                        f.freeze = false;
                    })
                }
                this.freezeIdx = this.confCols.findIndex(c=>!c.freeze);
            },
            // [DRAG] Column ordering start
            pdn(e) {
                // 1. Prevent default
                e.preventDefault();
                e.stopPropagation();
                // 2. get index
                //  e.target -> svg (...항상?)
                var t = e.currentTarget.parentElement,
                    idx = ~~t.getAttribute('data-idx');
                this.dragIdx  = idx;
                this.startIdx = idx;
                // x. Init drag event.
                // var tl = e.target;
                // tl.setPointerCapture(e.pointerId)
                // tl.onmousemove = this.pmv;
                //fixme safari 12를 포기합시다
                document.body.addEventListener('mousemove', this.pmv);
                document.body.addEventListener('mouseup', this.pup);
                // this.lakjsflkjasldkjf
            },
            // [DRAG] On moving
            pmv:_rafThrottle (function(e) {
                if(this.startIdx===null) return;
                var iw = this.$refs.iw, iwRect = iw.getBoundingClientRect();
                var mOffset = e.clientY - iwRect.top;
                var offset  = e.clientY - iwRect.top + iw.scrollTop;
                const H = 32, M = 10; //px - height, margin
                // 1. set index
                this.dragIdx = Math.floor((offset-H/2)/(H+M));
                // 2. scroll?
                const SCROLL_UNIT = 10;
                var iwst = iw.scrollTop;
                if(iwRect.height - mOffset < SCROLL_UNIT) {
                    iwst += SCROLL_UNIT; // 뭐 체크값이랑 더하기 값이랑 꼭 둘이 같을 필요는 없음
                    if(iwst > iw.scrollHeight) iwst = iw.scrollHeight;
                } else if(mOffset < SCROLL_UNIT) {
                    iwst -= SCROLL_UNIT
                    if(iwst < 0) iwst = 0;
                }
                iw.scrollTop = iwst;
                // this.lakjsflkjasldkjf
            })/**/,
            // [DRAG] End...
            pup(e) {
                var ori = this.startIdx, trg = this.dragIdx,
                    val = this.confCols[ori];
                if(!val) return; // DN없이 UP만 있슴

                // 1. Prevent default
                e.preventDefault();
                e.stopPropagation();

                // 2. Change order
                if(trg<ori) {
                    // @! 올라갈땐 옵셋이 한칸 반대로
                    trg+=1;
                    // @! 올렸는데도 마이너스면 0으로
                    if(trg<0) trg = 0;
                } else if(trg>=this.confCols.length) {
                    trg = this.confCols.length-1;
                }
                // 2.1 Re-ordering
                var c = this.confCols.filter((c,n)=>n!==ori)
                c.splice(trg,0,val)
                this.confCols = c;
                // 2.2 Set freeze
                if(val.freeze) {
                    // 2.2.1 얼은걸 내릴때, 내 앞칸이 녹았으면, 나도 녹이기
                    if(c[trg-1]&&!c[trg-1].freeze) {c[trg].freeze = false}
                } else {
                    // 2.2.2 안 얼은걸 올릴때는, 내 뒷칸이 얼었으면, 나도 얼리기
                    if(c[trg+1]&& c[trg+1].freeze) {c[trg].freeze = true}
                }/**/
                // 2.3 Re-calc freeze index
                this.freezeIdx = this.confCols.findIndex(c=>!c.freeze);
                // 3. reset index
                this.dragIdx  = null;
                this.startIdx = null;
                // x. Release drag event.
                // var tl = e.target;
                // tl.releasePointerCapture(e.pointerId)
                // tl.onmousemove = null;
                //fixme safari 12를 포기합시다
                document.body.removeEventListener('mousemove', this.pmv);
                document.body.removeEventListener('mouseup', this.pup);
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;

                if(charCode === 13){return true;}
                if(!window.isNaN(evt.key) && window.isFinite(evt.key)){
                    return true;
                }
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    let text = evt.target.value.replace(/[^0-9]/g,'');
                    evt.target.value = text;
                    evt.preventDefault();;
                } else {
                    return true;
                }
                return false;
            },
            filterNumber(evt) {
                let text = evt.target.value.replace(/[^0-9]/g,'');
                evt.target.value = text;
                return true;

            },
        },
        directives: {'click-outside': clickOutside}
    }
</script>

